import { render, staticRenderFns } from "./OrderAdmittance.vue?vue&type=template&id=59c06d94&scoped=true&"
import script from "./OrderAdmittance.vue?vue&type=script&lang=js&"
export * from "./OrderAdmittance.vue?vue&type=script&lang=js&"
import style0 from "./OrderAdmittance.vue?vue&type=style&index=0&id=59c06d94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c06d94",
  null
  
)

export default component.exports
import {QCard,QCardSection,QItem,QItemSection,QItemLabel,QChip,QAvatar,QBtn,QTooltip,QCardActions,QExpansionItem,QSeparator,ClosePopup} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QItem,QItemSection,QItemLabel,QChip,QAvatar,QBtn,QTooltip,QCardActions,QExpansionItem,QSeparator}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
